<template>
  <form class="bg-white shadow-md rounded" @submit.prevent>
    <p v-show="showLabel" class="text-dark-grey-1 mb-0 fs-13 fw-400">Date range</p>
    <div>
      <v-date-picker
        v-model="range"
        @input="handleDateInput(range)"
        mode="date"
        :max-date="extendedEndDate ? '' : new Date()"
        :masks="masks"
        is-range
      >
        <template v-slot="{ inputValue, inputEvents, isDragging }">
          <div :style="{ backgroundColor: `${bgColor} !important`, color: textColor, border: showBorder ? '1px solid #9DBCDC !important' : 'none !important' }" class="cursor-pointer form-control d-flex align-items-center" >
            <div>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 8C9.44772 8 9 7.55229 9 7C9 6.44771 9.44772 6 10 6C10.5523 6 11 6.44771 11 7C11 7.55229 10.5523 8 10 8ZM9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10C11 9.44771 10.5523 9 10 9C9.44772 9 9 9.44771 9 10ZM7 8C6.44771 8 6 7.55229 6 7C6 6.44771 6.44771 6 7 6C7.55229 6 8 6.44771 8 7C8 7.55229 7.55229 8 7 8ZM6 10C6 10.5523 6.44771 11 7 11C7.55229 11 8 10.5523 8 10C8 9.44771 7.55229 9 7 9C6.44771 9 6 9.44771 6 10ZM4 8C3.44771 8 3 7.55229 3 7C3 6.44771 3.44771 6 4 6C4.55229 6 5 6.44771 5 7C5 7.55229 4.55229 8 4 8ZM0 2.5C0 1.11929 1.11929 0 2.5 0H11.5C12.8807 0 14 1.11929 14 2.5V11.5C14 12.8807 12.8807 14 11.5 14H2.5C1.11929 14 0 12.8807 0 11.5V2.5ZM13 4H1V11.5C1 12.3284 1.67157 13 2.5 13H11.5C12.3284 13 13 12.3284 13 11.5V4ZM11.5 1H2.5C1.67157 1 1 1.67157 1 2.5V3H13V2.5C13 1.67157 12.3284 1 11.5 1Z" :fill="textColor"/>
                </svg>
            </div>
            <div class="mx-2">
                <svg width="2" height="19" viewBox="0 0 2 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.552 18.328C0.445333 18.328 0.354667 18.2907 0.28 18.216C0.216 18.152 0.184 18.0667 0.184 17.96V1.032C0.184 0.925333 0.216 0.84 0.28 0.775999C0.354667 0.701333 0.445333 0.664 0.552 0.664H1.176C1.28267 0.664 1.368 0.701333 1.432 0.775999C1.50667 0.84 1.544 0.925333 1.544 1.032V17.96C1.544 18.0667 1.50667 18.152 1.432 18.216C1.368 18.2907 1.28267 18.328 1.176 18.328H0.552Z" :fill="textColor"/>
                </svg>
            </div>
            <div class="d-flex align-items-center">
                <div class="material-icons fw-400 fs-20 ml-n2">
                    chevron_left
                </div>
                <p
                  v-on="inputEvents.start"
                  :style="{ color: `${textColor}` }"
                  class="fs-13  mb-0 ml-1">
                  {{ formatDate(inputValue) }}
                </p>
                <div class="material-icons fw-400 fs-20">
                    chevron_right
                </div>
            </div>
          </div>
        </template>
      </v-date-picker>
    </div>
  </form>
</template>
<script>
  export default {
    name: 'DateRangePicker',
    props: {
        bgColor: {
            type: String,
            default: 'bg-white',
        },
        textColor: {
            type: String,
            default: '#454545',
        },
        showBorder: {
            type: Boolean,
            default: true
        },
        defaultStartDate: {
            type: Number,
            default: 30
        },
        dateFormat: {
            type: String,
            default: 'MMM DD, YYYY'
        },
        showLabel: {
          type: Boolean,
          default: true
        },
        extendedEndDate: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        range: {
          start: new Date().setDate(new Date().getDate() - this.defaultStartDate),
          end: this.extendedEndDate ? this.$moment().add(30, 'days').toDate() : new Date()
        },
        rangeValue: {},
        masks: {
          input: 'YYYY-MM-DD',
        },
      }
    },
    methods: {
      formatDate(value) {
        const startDate = this.$moment(value.start).format(this.dateFormat)
        const endDate = this.$moment(value.end).format(this.dateFormat)

        return `${startDate} - ${endDate}`
      },
      handleDateInput(value) {
        const start_date = this.$moment(value.start).format('YYYY-MM-DD')
        const end_date = this.$moment(value.end).format('YYYY-MM-DD')
        this.rangeValue = {start_date, end_date};
      },
    },
    watch:{
      range: {
        immediate: true,
        deep: true,
        handler(newValue, oldValue) {
          if(oldValue === undefined) return
          this.$emit('input', this.rangeValue);
        }
      }
    },
    mounted() {
        this.handleDateInput(this.range)
        this.$emit('initial-value', this.rangeValue)
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep .vc-popover-content-wrapper {
    z-index: 999 !important;
  }

</style>
